import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { LinkInternoVoltarContainerService } from './link-interno-voltar-container.service';
import { LinkInternoVoltarData } from '@fcp/lib-ui';

@Component({
  selector: 'fcp-link-interno-voltar-container',
  template: `
    <fcp-link-interno-voltar
      [linkInternoVoltar]="data | async"
      (wasClickedPage)="wasClickedPage.emit($event)"
    ></fcp-link-interno-voltar>
  `
})
export class LinkInternoVoltarContainerComponent implements OnInit {
  @Input() public id: string;
  @Output() public wasClickedPage: EventEmitter<any> = new EventEmitter();

  public data: Observable<LinkInternoVoltarData>;
  constructor(private linkInternoVoltarContainerService: LinkInternoVoltarContainerService) {}

  ngOnInit() {
    this.data = this.linkInternoVoltarContainerService.getLinkInternoVoltar(this.id);
  }
}
